import { useState, useRef, createContext } from "react"

export const GlobalMobileContext = createContext([{}, () => {}])

export const GlobalMobileProvider = ( props ) => {

    const mobileSocketRef = useRef();
    const inputNoteRef = useRef()

    const [socketToken, setSocketToken] = useState();
    const [currentUser, setCurrentUser] = useState(null);
    const [currentPage, setCurrentPage] = useState(null);
    const [currentError, setCurrentError] = useState(null);    

    const [conferencesList, setConferencesList] = useState(null);
    const [currentProject, setCurrentProject] = useState(null);
    const [currentConference, setCurrentConference] = useState(null);
    const [currentNotesList, setCurrentNotesList] = useState(null);    
    const [currentTopicsList, setCurrentTopicsList] = useState(null);    
    const [selectedEntity, setSelectedEntity] = useState(null);


    const [projectIdParam, setProjectIdParam] = useState(null);
    const [conferenceIdParam, setConferenceIdParam] = useState(null);
    const [typeParam, setTypeParam] = useState(null);    
    const [topicIdParam, setTopicIdParam] = useState(null); 

    const [logOutPopup, setLogOutPopup] = useState(false)
    const [currentNote, setCurrentNote] = useState(null)
        

    return (
        <GlobalMobileContext.Provider value={{
            mobileSocketRef,    
            inputNoteRef, 
            socketToken, setSocketToken,       
            currentUser, setCurrentUser,
            currentPage, setCurrentPage,
            currentError, setCurrentError,    
            conferencesList, setConferencesList,
            currentProject, setCurrentProject,
            currentConference, setCurrentConference,
            currentNotesList, setCurrentNotesList,
            currentTopicsList, setCurrentTopicsList,
            projectIdParam, setProjectIdParam,
            conferenceIdParam, setConferenceIdParam, 
            typeParam, setTypeParam, 
            topicIdParam, setTopicIdParam,
            selectedEntity, setSelectedEntity,
            logOutPopup, setLogOutPopup,
            currentNote, setCurrentNote
        }}>
            {props.children}
        </GlobalMobileContext.Provider>
    )
}